module.exports = __webpack_public_path__ + "img/digi-dash.0dbbea77.jpg";